<template>
	<div :data-iframe-url="videoUrl">
		<div id="vimeoPlayer"></div>
	</div>
</template>

<script>
    import Player from "@vimeo/player";
    export default {
	    name: 'Player',
	    props: ['videoUrl', 'autoplay'],

	    data() { return {
		    player: null,
	    }},

	    methods: {
			setupVimeo() {
				this.player = new Player('vimeoPlayer', {
					url: this.videoUrl,
					width: 750,
					autoplay: this.autoplay,
				});

				console.log('[VimeoPlayer] Video player setup: ', this.player, this.videoUrl, this.autoplay);

				this.player.on('ended', () => {
					console.log('[VimeoPlayer] Video ended!');
					this.$emit('ended');
				});

				this.player.loadVideo({
					url: this.videoUrl,
					autoplay: this.autoplay
				});
			},
	    },

	    updated() {
			if (!this.videoUrl) {
				return;
			}

	        console.log('[VimeoPlayer] Video URL changed: ', this.videoUrl, this.autoplay);

		    this.setupVimeo();
	    },

	    mounted() {
		    console.log('[VimeoPlayer] Mounted: ', this.videoUrl, this.autoplay);
		    setTimeout(() => this.setupVimeo(), 500)
	    },
    }
</script>
